import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'label'>({ name: 'Related' })((_, __, classes) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 32
    },
    title: {
        fontSize: 36,
        fontWeight: 800
    },
    chip: {
        marginRight: 8,
        marginBottom: 8,
        textTransform: 'capitalize'
    },
    label: {},
    primary: {
        [`& .${classes.label}`]: {
            fontWeight: 600,
            color: '#fff'
        }
    }
}));
